<template>
  <div class="auth-full-screen-spinner" role="status" aria-live="polite">
    <div class="auth-full-screen-spinner__loading" aria-hidden="true" />
  </div>
</template>

<style lang="scss" scoped>
/* Same pattern as coral.club `.full-screen-spinner` / `.loading` */
.auth-full-screen-spinner {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.8);
}

.auth-full-screen-spinner__loading {
  width: 35px;
  height: 35px;
  border: 0.35rem solid #c2c2c2;
  border-top-color: #8fbf60;
  border-radius: 50%;
  animation: auth-spin 1s infinite linear;
}

@keyframes auth-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
